module.exports = __webpack_public_path__ + "img/cg4.9c83d3c1.jpg";